module.exports = __webpack_public_path__ + "static/media/davidoff-cool-water-big.f356a4e9.png";